import { type FC } from "react";
import { Table, Td, Th, Tr } from "@root/shared/components/Table";
import { SelectBox } from "@root/shared/components/SelectBox";
import { useFormContext } from "react-hook-form";
import { Label } from "@root/shared/components/Label";
import { type InputMessageViewProps } from "@clientFrontend/features/entry/components/NotAdopted/type";
import * as styles from "./styles.css";

export const PcView: FC<InputMessageViewProps> = ({
  selectBoxOptions,
  mailBody,
  selectedMessageType,
}) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <Table>
      <Tr>
        <Th width="168px" className={styles.formItem}>
          メール内容
          <Label theme="deepPink" className={styles.formLabel}>
            必須
          </Label>
        </Th>
        <Td>
          <SelectBox
            {...register("message", {
              required: "選択してください。",
            })}
            hasError={!!errors.message}
            selected={!!selectedMessageType}
            options={selectBoxOptions}
            placeholder="メールの内容を選択してください"
            className={styles.formSelectBox}
          />
          {errors.message && <p className={styles.errorMessage}>{errors.message.message}</p>}
          {!!selectedMessageType && mailBody}
        </Td>
      </Tr>
    </Table>
  );
};
